import { render, staticRenderFns } from "./fu-header.vue?vue&type=template&id=8c7f2396&scoped=true&"
import script from "./fu-header.vue?vue&type=script&lang=js&"
export * from "./fu-header.vue?vue&type=script&lang=js&"
import style0 from "./fu-header.vue?vue&type=style&index=0&id=8c7f2396&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7f2396",
  null
  
)

component.options.__file = "fu-header.vue"
export default component.exports